// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__-zIuh","modal__inner":"modal_modal__inner__Yb7uR","wide":"modal_wide__Tos7h","modal__inner-logo":"modal_modal__inner-logo__5vfU9"};